module.exports = __webpack_public_path__ + "img/clouds.e350e46e.svg";